<!-- THE CLOSE SELECTION (CR-20260916-003, owner sketch 2026-09-16). Under the Ignore / Close
     buttons while Close is selected: the book's expirations as toggles, and one box per toggled
     expiration — Calls / Puts / Total with their sums, then the CALLS and PUTS lists, one row per
     hedge: checkbox + name left, live close price far right. -->
<div class="close-selection" data-element="maven-close-selection">

  <div class="label">Available Expirations</div>

  <div class="chips" data-element="maven-close-expirations">
    <!-- The SELECTED chips paint yellow when the toggled set differs from the run's (the diff
         is over the SET, as the ORION Close tab's own chips do). -->
    <div class="chip"
         *ngFor="let e of this.expirations; trackBy: this.trackByDate"
         [class.selected]="this.isExpirationOn(e.date)"
         [class.param-changed]="this.isExpirationOn(e.date) && this.expirationsChanged()"
         [class.disabled]="this.disabled"
         [attr.data-element]="'maven-close-exp-' + e.date"
         (click)="this.toggleExpiration(e.date)">{{ e.label }}</div>
    <div class="empty" *ngIf="!this.loading && this.expirations.length === 0">No hedges on the book.</div>
    <div class="empty" *ngIf="this.loading">Reading the hedge book…</div>
  </div>

  <div class="box" *ngFor="let b of this.boxes; trackBy: this.trackByDate"
       [attr.data-element]="'maven-close-box-' + b.date">

    <div class="box-head">{{ b.header }}</div>

    <!-- Three evenly spaced checkboxes with the side sums and the total. Partial = the
         DevExtreme three-state box (value undefined). -->
    <div class="agg">
      <div class="agg-item">
        <dx-check-box [value]="this.groupValue(b, 'calls')"
                      [disabled]="this.disabled || b.calls.length === 0"
                      text="Calls"
                      [attr.data-element]="'maven-close-calls-' + b.date"
                      (onValueChanged)="this.onGroupToggle(b, 'calls', $event)"></dx-check-box>
        <span class="money" [class.credit]="this.signClass(this.groupPrice(b, 'calls')) === 'credit'"
              [class.debit]="this.signClass(this.groupPrice(b, 'calls')) === 'debit'">{{ this.moneyText(this.groupPrice(b, 'calls')) }}</span>
      </div>
      <div class="agg-item">
        <dx-check-box [value]="this.groupValue(b, 'puts')"
                      [disabled]="this.disabled || b.puts.length === 0"
                      text="Puts"
                      [attr.data-element]="'maven-close-puts-' + b.date"
                      (onValueChanged)="this.onGroupToggle(b, 'puts', $event)"></dx-check-box>
        <span class="money" [class.credit]="this.signClass(this.groupPrice(b, 'puts')) === 'credit'"
              [class.debit]="this.signClass(this.groupPrice(b, 'puts')) === 'debit'">{{ this.moneyText(this.groupPrice(b, 'puts')) }}</span>
      </div>
      <div class="agg-item">
        <dx-check-box [value]="this.groupValue(b, 'all')"
                      [disabled]="this.disabled"
                      text="Total"
                      [attr.data-element]="'maven-close-total-' + b.date"
                      (onValueChanged)="this.onGroupToggle(b, 'all', $event)"></dx-check-box>
        <span class="money" [class.credit]="this.signClass(this.groupPrice(b, 'all')) === 'credit'"
              [class.debit]="this.signClass(this.groupPrice(b, 'all')) === 'debit'">{{ this.moneyText(this.groupPrice(b, 'all')) }}</span>
      </div>
    </div>

    <ng-container *ngIf="b.calls.length > 0">
      <div class="group-divider"><span>CALLS</span></div>
      <!-- Changed-vs-run (owner vrequest 2026-09-16): a hedge ADDED or REMOVED since the run
           carries a yellow border around its NAME — nothing on the unchanged rows, nothing on
           the checkbox, nothing on the aggregate boxes. -->
      <div class="hedge-row" *ngFor="let h of b.calls; trackBy: this.trackById"
           [attr.data-element]="'maven-close-hedge-' + h.id">
        <dx-check-box [value]="this.isSelected(h.id)"
                      [disabled]="this.disabled"
                      (onValueChanged)="this.onHedgeToggle(h.id, $event.value, $event)"></dx-check-box>
        <span class="hedge-name" [class.hedge-name--changed]="this.hedgeChanged(h.id)"
              (click)="this.onHedgeToggle(h.id, !this.isSelected(h.id))">{{ h.name }}<span class="cal" *ngIf="h.isCalendar"> (cal)</span></span>
        <span class="money" [class.credit]="this.signClass(this.hedgePrice(h.id)) === 'credit'"
              [class.debit]="this.signClass(this.hedgePrice(h.id)) === 'debit'">{{ this.moneyText(this.hedgePrice(h.id)) }}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="b.puts.length > 0">
      <div class="group-divider"><span>PUTS</span></div>
      <div class="hedge-row" *ngFor="let h of b.puts; trackBy: this.trackById"
           [attr.data-element]="'maven-close-hedge-' + h.id">
        <dx-check-box [value]="this.isSelected(h.id)"
                      [disabled]="this.disabled"
                      (onValueChanged)="this.onHedgeToggle(h.id, $event.value, $event)"></dx-check-box>
        <span class="hedge-name" [class.hedge-name--changed]="this.hedgeChanged(h.id)"
              (click)="this.onHedgeToggle(h.id, !this.isSelected(h.id))">{{ h.name }}<span class="cal" *ngIf="h.isCalendar"> (cal)</span></span>
        <span class="money" [class.credit]="this.signClass(this.hedgePrice(h.id)) === 'credit'"
              [class.debit]="this.signClass(this.hedgePrice(h.id)) === 'debit'">{{ this.moneyText(this.hedgePrice(h.id)) }}</span>
      </div>
    </ng-container>

  </div>

</div>
